export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/dotnet-service-stack-form';
